import { render, staticRenderFns } from "./RentalCard.vue?vue&type=template&id=1db84772"
import script from "./RentalCard.vue?vue&type=script&lang=js"
export * from "./RentalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports